import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "orderBy",
})
export class OrderByPipe implements PipeTransform {
    transform(array: any[], order: string = "asc"): any[] {
        if (!array || array.length <= 1) {
            return array;
        }

        array.sort((a, b) => {
            if (order === "asc") {
                return a.value.order - b.value.order;
            } else {
                return b.value.order - a.value.order;
            }
        });

        return array;
    }
}
